import { useRealtime } from "#/src/util/realtime";
import { handleSessionAvailable, handleSessionClaimed } from "#/src/providers/tutorRealtimeStore";
import { logTutorEvent } from "#/src/utils/log";

const ACTIONS: ("marketplace-session-available" | "marketplace-session-claimed")[] = [
  "marketplace-session-available",
  "marketplace-session-claimed",
];

/**
 * Subscribes to last-minute SNTS realtime events for the active tutor and
 * routes them to the shared session handlers in `tutorRealtimeStore`.
 *
 * Mount this once (typically from `TutorRealtimeProvider`); pass `enabled: false` to
 * tear the subscription down (e.g. when the tutor is not in an active SNTS
 * connection window).
 */
export function useMarketplaceTutorRealtime({
  tutorId,
  enabled,
}: {
  tutorId: string | null | undefined;
  enabled: boolean;
}) {
  useRealtime({ entityId: tutorId, enabled }, ACTIONS, (message) => {
    logTutorEvent({ eventName: "marketplace.nats.message_received", metadata: { message } });

    if (message.action === "marketplace-session-available") {
      handleSessionAvailable(message.payload);
    } else if (message.action === "marketplace-session-claimed") {
      handleSessionClaimed(message.payload);
    }
  });
}
